import qs from 'qs';
import { network } from 'services/network';

export const getFragnetMilestones = ({
    latestVersion,
    filter,
    taskVersionHashCode,
}: {
    latestVersion: number;
    filter?: string;
    taskVersionHashCode?: string | null;
}) => {
    const querystring = qs.stringify(
        { metaDataId: latestVersion, filter, taskVersionHashCode },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getFragnetMilestones${querystring}`;

    return network.post(url).then((response) => {
        return response.data;
    });
};
